import { render } from "./EchartsMap.vue?vue&type=template&id=1cbcd39e"
import script from "./EchartsMap.vue?vue&type=script&lang=js"
export * from "./EchartsMap.vue?vue&type=script&lang=js"
script.render = render

export default script